<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                v-model="queryParams.productCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="warehouseList"
                label="Warehouse"
                v-model="queryParams.warehouseId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="categoryList"
                label="Category"
                v-model="queryParams.categoryId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="brandList"
                label="Brand"
                v-model="queryParams.brandId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="productGroupList"
                label="ProductGroup"
                v-model="queryParams.productGroupId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="priceTypeList"
                label="Type"
                v-model="queryParams.priceType"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
             <v-flex sm3>
                <v-autocomplete
                  v-model="queryParams.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  menu-props="auto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-card class="font-weight-bold">
                <v-card-title class="blue darken-3">
                  <span class="headline white--text">Summary</span>
                </v-card-title>
                <v-card-text class="font-weight-bold">
                  <div>
                    <span>Total Amount :</span>
                    <v-chip>
                      <span>{{ totalAmount | decFormat}}</span>
                    </v-chip>
                    <v-btn
                      :loading="buttonLoading"
                      color="primary"
                      @click="printAllStockValuationReport('printStockValuationReport')"
                    >PRINT ALL</v-btn>
                    <v-btn
                      :loading="buttonLoading"
                      color="success"
                      @click="exportAllStockValuation()"
                    >EXPORT ALL</v-btn>
                  </div>
                  <div>
                    <span>Total Qty :</span>
                    <v-chip>
                      <span>{{ totalQty }}</span>
                    </v-chip>
                  </div>
                  <div>
                    <span>Currency :</span>
                    <v-chip>
                      <span>{{ currencyCode }}</span>
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :must-sort="true"
                  :headers="headers"
                  :items="stockList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>{{ props.item.warehouse.name }}</td>
                      <td>{{ props.item.product.name }}</td>
                      <td>{{ props.item.product.productGroupName}}</td>
                      <td>{{ props.item.product.code +"/" + props.item.brand.name +"/"+props.item.category.name }}</td>
                      <td>{{ props.item.productUnit.factor +"/" + props.item.productUnit.unitName }}</td>
                      <td
                        v-if="queryParams.priceType == 'Unit Cost' "
                      >{{ props.item.productUnit.unitCost}}</td>
                      <td
                        v-else-if="queryParams.priceType == 'Selling Price' "
                      >{{ props.item.productUnit.sellingPrice}}</td>
                      <td 
                        v-else-if="queryParams.priceType == 'Buying Price' "
                      >{{ props.item.productUnit.buyingPrice }}</td>
                      <td 
                        v-else-if="queryParams.priceType == 'Wholesale Price' "
                      >{{ props.item.productUnit.wholesalePrice }}</td>
                      <td>{{ props.item.qty }}</td>
                      <td
                        v-if="queryParams.priceType == 'Unit Cost' "
                      >{{ props.item.productUnit.unitCost * props.item.qty | decFormat }}</td>
                      <td
                        v-else-if="queryParams.priceType == 'Selling Price' "
                      >{{ props.item.productUnit.sellingPrice * props.item.qty | decFormat }}</td>
                      <td 
                        v-else-if="queryParams.priceType == 'Buying Price' "
                      >{{ props.item.productUnit.buyingPrice * props.item.qty | decFormat }}</td>
                      <td 
                        v-else-if="queryParams.priceType == 'Wholesale Price' "
                      >{{ props.item.productUnit.wholesalePrice * props.item.qty | decFormat }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <!-- <summary report> -->
            <div
              id="printStockValuationReport"
              style="bsale:1px solid black;width:300px;"
              v-show="false"
            >
              <div style="text-align:center">
                <p style="font-size:18px;margin:1px">Stock Valuation Report</p>
              </div>
              <div style="text-align:center">
                <p style="font-size:15px;margin:1px">Report Date : [{{date}}]</p>
              </div>
              <div style="text-align:center">
                <p style="font-size:15px;margin:1px">Total Amount : [{{totalAmount | decFormat}}]</p>
              </div>
              <div style="text-align:center">
                <p style="font-size:15px;margin:1px">Total Qty : [{{ totalQty }}]</p>
              </div>
              <div style="text-align:center">
                <p style="font-size:15px;margin:1px">Currency : [{{ currencyCode }}]</p>
              </div>
              <br />
              <div style="padding-left:5px;padding-right:5px">
                <table
                  style="font-family: arial, sans-serif;border-collapse: collapse;
          width: 100%;font-size:11px;border-top:1px solid black"
                >
                  <thead style="border-bottom:1px solid black;border-top:1px solid black">
                    <tr>
                      <th style="text-align:left">Warehouse Name</th>
                      <th style="text-align:left">Product Name</th>
                      <th style="text-align:left">Product Group</th>
                      <th style="text-align:left">Code/Category/Brand</th>
                      <th style="text-align:left">Factor/Unit</th>
                      <th style="text-align:left">Type Price</th>
                      <th style="text-align:left">Qty</th>
                      <th style="text-align:left">Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in allStockValuationReportList" :key="index">
                      <td style="text-align:left">{{item.warehouse.name}}</td>
                      <td style="text-align:left">{{item.product.name}}</td>
                      <td style="text-align:left">{{item.product.productGroupName}}</td>
                      <td
                        style="text-align:left"
                      >{{item.product.code + "/"+ item.brand.name +"/"+item.category.name}}</td>
                      <td
                        style="text-align:left"
                      >{{item.productUnit.factor + "/"+ item.productUnit.unitName}}</td>
                      <td
                        style="text-align:left"
                        v-if="queryParams.priceType == 'Unit Cost' "
                      >{{item.productUnit.unitCost}}</td>
                      <td
                        style="text-align:left"
                        v-else-if="queryParams.priceType == 'Selling Price' "
                      >{{item.productUnit.sellingPrice}}</td>
                      <td 
                        style="text-align:left" 
                        v-else-if="queryParams.priceType == 'Buying Price' "
                      >{{ item.productUnit.buyingPrice }}</td>
                      <td 
                        style="text-align:left" 
                        v-else-if="queryParams.priceType == 'Wholesale Price' "
                      >{{ item.productUnit.wholesalePrice }}</td>
                      <td style="text-align:left">{{item.qty}}</td>
                      <td
                        style="text-align:left"
                        v-if="queryParams.priceType == 'Unit Cost' "
                      >{{ item.productUnit.unitCost * item.qty }}</td>
                      <td
                        style="text-align:left"
                        v-else-if="queryParams.priceType == 'Selling Price' "
                      >{{ item.productUnit.sellingPrice * item.qty}}</td>
                      <td style="text-align:left" v-else-if="queryParams.priceType == 'Buying Price' "
                        >{{ item.productUnit.buyingPrice * item.qty }}</td>
                      <td style="text-align:left" v-else-if="queryParams.priceType == 'Wholesale Price' "
                        >{{ item.productUnit.wholesalePrice * item.qty }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { stockService } from "../../services/stock-service";
import { categoryService } from "../../services/category-service";
import { brandService } from "../../services/brand-service";
import { warehouseService } from "../../services/warehouse-service";
import { productGroupService } from "../../services/product-group-service";
import { currencyService } from "../../services/currency-service";

export default {
  name: "StockValuationReport",
  components: {},
  data: () => ({
    date: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "Stock Valuation Report",
        disabled: true
      }
    ],
    headers: [
      { text: "Warehouse", align: "left", sortable: false },
      { text: "Product Name", sortable: false },
      { text: "Product Group", sortable: false },
      { text: "Code/Category/Brand", sortable: false },
      { text: "Factor/Unit", sortable: false },
      { text: "Type Price", sortable: false },
      { text: "Qty", value: "qty" },
      { text: "Total Amount", sortable: false }
    ],
    clonequeryParams: new Object(),
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "created_date",
      totalItems: 0
    },
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    priceTypeList: [
      { label: "Unit Cost", value: "Unit Cost" },
      { label: "Selling Price", value: "Selling Price" },
      { label: "Buying Price", value: "Buying Price" },
      { label: "Wholesale Price", value: "Wholesale Price" }
    ],
    queryParams: {
      productCode: "",
      categoryId: "",
      brandId: "",
      warehouseId: "",
      productGroupId: "",
      status: "ACTIVE",
      priceType: "",
      currencyId: ""
    },
    currencyList: [],
    showListLoading: false,
    buttonLoading: false,
    warehouseList: [],
    categoryList: [],
    productGroupList: [],
    brandList: [],
    stockList: [],
    allStockValuationReportList: [],
    totalRows: 0,
    totalQty: 0,
    currencyCode: "",
    totalAmount: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockValuationReport();
      },
      deep: true
    }
  },

  created() {
    this.queryParams.status = "ACTIVE";
    this.queryParams.priceType = "Unit Cost";
    //for deep linking
    if (this.$route.query.productCode) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.priceType) {
      this.queryParams.priceType = this.$route.query.priceType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.getBrandList();
    this.getCategoryList();
    this.getProductGroupList();
    this.clonequeryParams = Object.assign({}, this.queryParams);
    this.getActiveCurrency()
    .finally(() => {
        this.onSearch();
    });
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "StockValuationReport",
        query: this.queryParams
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getStockValuationReport();
      let c = commonService.search("id",this.queryParams.currencyId,this.currencyList);
        if(c){
          this.currencyCode = c.code;
        }
    },
    getActiveCurrency(){
    return currencyService.getCurrencyByStatus('ACTIVE')
    .then(res => {
      if(res.data){
        this.currencyList = res.data;
        let c = commonService.search("defaultCurrency",true,this.currencyList);
        if(c){
          this.queryParams.currencyId = c.id;
        }
      }
    })
    .catch((err) => {
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },
    printAllStockValuationReport(divName) {
      if(this.queryParams.currencyId){
        let currency = commonService.search("id", this.queryParams.currencyId, this.currencyList);
        this.currencyCode =currency.code;
      }
      this.buttonLoading = true;
      this.allStockValuationReportList = [];
      stockService
        .getAllStockValuationReport(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.allStockValuationReportList = res.data.stockList;
            this.totalAmount = res.data.totalAmount;
            this.totalQty = res.data.totalStockQty;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
        });
    },

    getStockValuationReport() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockService
        .getStockValuationReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.stockList = res.data.stockList;
            this.totalRows = res.data.totalElements;
            this.totalQty = res.data.totalStockQty;
            this.totalAmount = res.data.totalAmount;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getWarehouseList() {
      warehouseService
        .getAllWarehouse()
        .then(res => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    getCategoryList() {
      categoryService
        .getAllCategory()
        .then(res => {
          this.categoryList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.categoryList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    getBrandList() {
      brandService
        .getAllBrand()
        .then(res => {
          this.brandList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.brandList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    getProductGroupList() {
      productGroupService
        .getAllProductGroup()
        .then(res => {
          this.productGroupList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.productGroupList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch(err => {
          console.log(err);
        });
    },
    exportAllStockValuation() {
      this.buttonLoading = true;
      stockService
        .exportStockValuationExcel(this.clonequeryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    }
  }
};
</script>
